// extracted by mini-css-extract-plugin
export default {"details":"Details_details__zhRZh","rightDetails":"Details_rightDetails__vNWoL","leftDetails":"Details_leftDetails__i7Evl","itemTitle":"Details_itemTitle__NEPt6"};